export default "__VITE_ASSET__458f82c4__"